<template>
  <OQInput
    :label="label"
    :title="title"
    :hint="hint"
    :placeholder="placeholder"
    :value="value"
    :required="required"
    @input="(v) => $emit('input', v)"
  />
</template>

<script>
import OQInput from "@/components/UI/OQInput.vue";

export default {
  name: "OQFioInput",
  components: { OQInput },
  props: ["label", "hint", "title", "placeholder", "value", "required"],
};
</script>

<style scoped></style>
